import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';

const DEFAULT_COLORS = ['#4e79a7', '#e15759'];

/**
 * LineChartCard — 시계열 일별 추이 라인 차트 wrapper (1~2 line).
 * 사용법: docs/modules/frontend/chart/LineChartCard.md
 */
const LineChartCard = ({
  data, xKey, yKey, yKey2 = null,
  yLabel = '', yLabel2 = '', title,
  width = 400, height = 300, formatY = null,
}) => {
  const safeData = Array.isArray(data) ? data : [];
  const w = typeof width === 'number' ? `${width}px` : width;
  const h = typeof height === 'number' ? `${height}px` : height;

  if (safeData.length === 0) {
    return (
      <div data-testid="line-chart-card"
        style={{ width: w, height: h, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span>표시할 데이터가 없습니다</span>
      </div>
    );
  }

  const labels = [yLabel || yKey];
  if (yKey2) labels.push(yLabel2 || yKey2);
  const fmt = typeof formatY === 'function' ? formatY : null;

  return (
    <div data-testid="line-chart-card" style={{ width: w, height: h }}>
      {title ? <div style={{ textAlign: 'center', fontWeight: 600 }}>{title}</div> : null}
      {/* 테스트 가시성 마커 (jsdom 에서 svg 미렌더 대비, DonutChart 패턴 정합) */}
      <div style={{ display: 'none' }} aria-hidden="true">
        {labels.map((label, idx) => (
          <span key={`l-${idx}`} data-testid="line-chart-line" data-label={label} />
        ))}
        {safeData.map((d, i) => {
          const raw = d[yKey];
          return (
            <span key={`pt-${i}`} data-testid="line-chart-point"
              data-x={d[xKey]} data-y={raw}
              data-formatted={fmt ? fmt(raw) : String(raw)} />
          );
        })}
      </div>
      <ResponsiveContainer width="100%" height={title ? height - 24 : height}>
        <LineChart data={safeData}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--card-border)" />
          <XAxis dataKey={xKey} />
          <YAxis tickFormatter={fmt || undefined} />
          <Tooltip formatter={fmt || undefined} />
          {yKey2 ? <Legend /> : null}
          <Line type="monotone" dataKey={yKey} stroke={DEFAULT_COLORS[0]}
            name={yLabel || yKey} strokeWidth={2} dot={false} isAnimationActive={false} />
          {yKey2 ? (
            <Line type="monotone" dataKey={yKey2} stroke={DEFAULT_COLORS[1]}
              name={yLabel2 || yKey2} strokeWidth={2} dot={false} isAnimationActive={false} />
          ) : null}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChartCard;
